import {Component, Input, OnInit} from "@angular/core";
import {UploadFormConfig} from "../../upload/upload-form-config";
import {formatDateFromIso} from "../../../tools/date-time-utils";
import {LocalizationStrings} from "../../../i18n/i18n-model";
import {I18nService} from "../../../i18n/i18n.service";

@Component({
  selector: "app-basic-patient-data-display",
  templateUrl: "./basic-patient-data-display.component.html",
  standalone: false,
})
export class BasicPatientDataDisplayComponent implements OnInit {

  dateOfBirthValue!: string;
  dateOfBirthLabel!: keyof LocalizationStrings;

  @Input() patientDataFields!: UploadFormConfig;

  constructor(private readonly i18nService: I18nService) {
  }

  ngOnInit(): void {

    if(this.patientDataFields.dateOfBirth === undefined) {
      return;
    }

    const model = this.patientDataFields.dateOfBirth!.model;

    const localizedDateOfBirth = formatDateFromIso(model.dateOfBirth!);
    const calculatedAge = model.calculatedAge!;
    const ageUnit = this.i18nService.getLocalizedString("uploadFormInfoLabelAge");

    this.dateOfBirthValue = `${localizedDateOfBirth} (${calculatedAge} ${ageUnit})`;
    this.dateOfBirthLabel = this.patientDataFields.dateOfBirth!.label;
  }
}
